"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setCookiesEnabled = exports.cookiesEnabled = exports.getClientId = void 0;
var logger_1 = require("./logger");
var uuid_1 = require("uuid");
var js_cookie_1 = __importDefault(require("js-cookie"));
var parse_domain_1 = require("@snapchat/parse-domain");
var log = (0, logger_1.getLogger)("clientId");
var clientId = null;
function getClientId() {
    var _a;
    if (clientId === null) {
        var str = exports.cookiesEnabled ? js_cookie_1["default"].get(COOKIE_NAME) : undefined;
        clientId = str ? ClientId.parse(str) : null;
        if (clientId !== null) {
            log.debug("Loaded clientId", clientId);
        }
    }
    if ((_a = clientId === null || clientId === void 0 ? void 0 : clientId.isExpired()) !== null && _a !== void 0 ? _a : true) {
        renewAndSaveClientId();
    }
    if (clientId === null) {
        throw "Unexpected null clientId";
    }
    return clientId.id;
}
exports.getClientId = getClientId;
function renewAndSaveClientId() {
    log.info("Generating new clientId");
    clientId = ClientId.generate();
    if (exports.cookiesEnabled) {
        js_cookie_1["default"].set(COOKIE_NAME, clientId.serialize(), {
            expires: cookiesExpireDays,
            domain: cookiesDomain
        });
        log.info("clientId is set in Cookies");
    }
}
var ClientId = (function () {
    function ClientId(data) {
        Object.assign(this, data);
    }
    ClientId.generate = function () {
        return new ClientId({
            id: (0, uuid_1.v4)(),
            timestamp: new Date().getTime()
        });
    };
    ClientId.parse = function (serialized) {
        var ar = serialized.split(":");
        if (ar.length === 1) {
            ar.push("".concat(new Date().getTime()));
        }
        if (ar.length !== 2) {
            return null;
        }
        var data = {
            id: ar[0],
            timestamp: parseInt(ar[1], 10)
        };
        if (!(0, uuid_1.validate)(data.id)) {
            return null;
        }
        if (isNaN(data.timestamp)) {
            return null;
        }
        return new ClientId(data);
    };
    ClientId.prototype.isExpired = function () {
        var now = new Date();
        return now > new Date(this.timestamp + EXPIRES_AFTER_MILLIS) || now < new Date(this.timestamp);
    };
    ClientId.prototype.serialize = function () {
        return "".concat(this.id, ":").concat(this.timestamp);
    };
    return ClientId;
}());
exports.cookiesEnabled = true;
var cookiesDomain = typeof self !== "undefined" ? (0, parse_domain_1.getTopLevelDomain)(self.location.hostname) : ".snapchat.com";
var cookiesExpireDays = 30;
function setCookiesEnabled(enabled, domainName, expireDays) {
    if (domainName === void 0) { domainName = ".snapchat.com"; }
    if (expireDays === void 0) { expireDays = 30; }
    exports.cookiesEnabled = enabled;
    cookiesDomain = domainName;
    cookiesExpireDays = expireDays;
}
exports.setCookiesEnabled = setCookiesEnabled;
var COOKIE_NAME = "blizzard_client_id";
var EXPIRES_AFTER_MILLIS = 30 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=clientId.js.map